import { Chip } from '@components/std-components/Chip'
import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import moment from 'moment'
import React, { FC } from 'react'
import ChipListSkeleton from '../../../CellLoaders/ChipListSkeleton'
import * as css from './SalesPeriod.css'

const SalesPeriod: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    if (!rowData) {
      return (
        <div>
          <ChipListSkeleton count={1} />
        </div>
      )
    }

    const salesPeriod = get(rowData, column.field)

    return (
      <div className={css['salesPeriodContainer']}>
        {salesPeriod ? (
          <Chip
            tooltip={`${salesPeriod.Name}\n${
              salesPeriod?.Start
                ? moment(new Date(salesPeriod.Start)).format('DD-MMM-YYYY')
                : ''
            } to ${
              salesPeriod?.End
                ? moment(new Date(salesPeriod.End)).format('DD-MMM-YYYY')
                : ''
            }`}
          >
            <Typography variant='body2' color='primary' classes={css['salesPeriodText']}>
              {salesPeriod?.Name}
            </Typography>
          </Chip>
        ) : (
          <Typography variant='caption2'>{'NA'}</Typography>
        )}
      </div>
    )
  })

export default SalesPeriod
